// Line-art "F" mark styled as an infinity loop carrying the flag of an F.
// Placeholder brand mark — swap for the uploaded logo file when provided.
export const Logo = ({ className = "", stroke = "#1a2a8f" }) => {
  return (
    <svg
      viewBox="0 0 64 44"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Formline"
    >
      {/* infinity loop */}
      <path
        d="M20 22c0-7-6-12-12-12S-1 15-1 22s5 12 8 12c8 0 12-24 24-24 6 0 9 5 9 12s-3 12-9 12"
        transform="translate(6 0)"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
      />
      {/* F flag stems */}
      <path
        d="M30 8h20M30 22h13"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
      />
      <path
        d="M30 8v28"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Logo;
